<ng-container>
    <mat-card class="mat-elevation-z0">
        <div class="order-name">
            <div class="row">
                <div class="col-12 col-sm-5 col-lg-3">
                    <label>{{ 'product.order' | translate }} </label>
                    <h2 class="mat-title text-blue font-weight-bold" [ngSwitch]="product.order.type">
                        <span *ngSwitchCase="OrderType.EXTERNAL_TRANSFER">{{ 'form.order-type.external-transfer' | translate }}</span>
                        <span *ngSwitchCase="OrderType.INTERNAL_TRANSFER">{{ 'form.order-type.internal-transfer' | translate }}</span>
                        <span *ngSwitchCase="OrderType.REFUND">{{ 'form.order-type.refund' | translate }}</span>
                        <span *ngSwitchCase="OrderType.REFUND_PERIOD">
                            <ng-container *ngIf="product.order.canceled">{{
                                'form.order-type.refund-period-canceled' | translate
                            }}</ng-container>
                            <ng-container *ngIf="!product.order.canceled">{{ 'form.order-type.refund-period' | translate }}</ng-container>
                        </span>
                        <span *ngSwitchCase="OrderType.SUBSCRIPTION">{{ 'form.order-type.subscription' | translate }}</span>
                        <span *ngSwitchCase="OrderType.SUBSCRIPTION_PERIOD">
                            <ng-container *ngIf="product.order.canceled">{{
                                'form.order-type.subscription-period-canceled' | translate
                            }}</ng-container>
                            <ng-container *ngIf="!product.order.canceled">{{
                                'form.order-type.subscription-period' | translate
                            }}</ng-container>
                        </span>
                    </h2>
                </div>
                <div class="col-12 col-sm-7 col-lg-5 mt-3 mt-sm-0">
                    <label>{{ 'product.name' | translate }}</label>
                    <h2 class="mat-title text-blue font-weight-bold">
                        {{ product.name }}
                    </h2>
                </div>
                <div class="col-12 col-lg-4 mt-3 mt-lg-0">
                    <h4 class="font-weight-normal" *ngIf="product.order.date">
                        <label class="mb-0">{{ 'operative.entry-date' | translate }}:</label>&nbsp;
                        <strong>{{ product.order.date?.toDate() | date: 'dd-MM-yyyy HH:mm:ss' }}</strong>
                    </h4>
                    <p class="mb-0">
                        <label class="mb-0">{{ 'operative.status' | translate }}:</label>&nbsp;
                        <strong class="text-uppercase text-error" [ngSwitch]="product.status">
                            <span *ngSwitchCase="SelectedProductStatus.ACCEPTED">{{ 'operative.statuses.accepted' | translate }}</span>
                            <span *ngSwitchCase="SelectedProductStatus.ACTIVE">{{ 'operative.statuses.active' | translate }}</span>
                            <span *ngSwitchCase="SelectedProductStatus.CANCELED">{{ 'operative.statuses.canceled' | translate }}</span>
                            <span *ngSwitchCase="SelectedProductStatus.ERROR">{{ 'operative.statuses.error' | translate }}</span>
                            <span *ngSwitchCase="SelectedProductStatus.EXECUTED">{{ 'operative.statuses.executed' | translate }}</span>
                            <span *ngSwitchCase="SelectedProductStatus.EXPIRED">{{ 'operative.statuses.expired' | translate }}</span>
                            <span *ngSwitchCase="SelectedProductStatus.FOR_SIGNING">{{
                                'operative.statuses.for_signing' | translate
                            }}</span>
                            <span *ngSwitchCase="SelectedProductStatus.IN_PROCESS" [ngSwitch]="product.order.type">
                                <ng-container *ngSwitchCase="OrderType.EXTERNAL_TRANSFER">{{
                                    'operative.statuses.in_process_sent' | translate
                                }}</ng-container>
                                <ng-container *ngSwitchCase="OrderType.INTERNAL_TRANSFER">{{
                                    'operative.statuses.in_process_sent' | translate
                                }}</ng-container>
                                <ng-container *ngSwitchDefault>{{ 'operative.statuses.in_process' | translate }}</ng-container>
                            </span>
                            <span *ngSwitchCase="SelectedProductStatus.NON_SUCCESSFUL_SIGNATURE">{{
                                'operative.statuses.non_successful_signature' | translate
                            }}</span>
                            <span *ngSwitchCase="SelectedProductStatus.REJECTED">{{ 'operative.statuses.rejected' | translate }}</span>
                            <span *ngSwitchDefault>{{ 'operative.statuses.draft' | translate }}</span>
                        </strong>
                    </p>
                </div>
            </div>
        </div>

        <div class="order-summary">
            <!-- <table class="table participants">-->
            <table class="table participants" *ngIf="!product.isAutomatic">
                <thead>
                    <tr>
                        <th></th>
                        <th class="d-none d-md-table-cell">
                            {{ 'form.participants' | translate }}
                        </th>
                        <th>{{ 'form.name-and-surname' | translate }}</th>
                        <th class="d-none d-lg-table-cell">
                            {{ 'form.email' | translate }}
                        </th>
                        <th class="d-none d-lg-table-cell">
                            {{ 'form.phone' | translate }}
                        </th>
                        <th class="d-none d-sm-table-cell">
                            {{ 'operative.sign-type' | translate }}
                        </th>
                        <th>{{ 'operative.sign-status' | translate }}</th>
                        <th *ngIf="product.status === SelectedProductStatus.FOR_SIGNING && product.hasElectronicSign">
                            {{ 'operative.action' | translate }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-template ngFor let-participant [ngForOf]="product.order.clients" let-i="index">
                        <tr>
                            <td>
                                <i class="icon-natural-plus"></i>
                            </td>
                            <td class="d-none d-md-table-cell" [ngSwitch]="participant.participantRelation">
                                <strong class="text-uppercase text-blue" *ngSwitchCase="OrderClientRelation.TITULAR">
                                    <ng-container *ngIf="participant.isSoleHolder">{{ 'form.holder' | translate }}</ng-container>
                                    <ng-container *ngIf="!participant.isSoleHolder">{{ 'form.co-holder' | translate }}</ng-container>
                                </strong>
                                <strong class="text-uppercase text-blue" *ngSwitchCase="OrderClientRelation.AUTHORISED">
                                    {{ 'form.authorized' | translate }}
                                </strong>
                                <strong class="text-uppercase text-blue" *ngSwitchCase="OrderClientRelation.TUTOR">
                                    {{ 'form.tutor' | translate }}
                                </strong>
                                <strong class="text-uppercase text-blue" *ngSwitchDefault>
                                    {{ 'form.attorney-in-fact' | translate }}
                                </strong>
                            </td>
                            <td>
                                <strong>{{ participant.name }}</strong
                                >&nbsp;<strong>{{ participant.surname }}</strong>
                            </td>
                            <td class="d-none d-lg-table-cell">
                                <strong>{{ participant.email }}</strong>
                            </td>
                            <td class="d-none d-lg-table-cell">
                                <strong>{{ participant.phone }}</strong>
                            </td>
                            <td class="text-uppercase d-none d-sm-table-cell" [ngSwitch]="participant.signatureType">
                                <strong *ngSwitchCase="ClientSignatureType.IN_PERSON_ELECTRONIC">{{
                                    'operative.sign-digital-face-to-face-abbr' | translate
                                }}</strong>
                                <strong *ngSwitchCase="ClientSignatureType.REMOTE_ELECTRONIC">{{
                                    'operative.sign-digital-remote-abbr' | translate
                                }}</strong>
                                <strong *ngSwitchDefault>{{ 'operative.sign-handwriting-abbr' | translate }}</strong>
                            </td>
                            <td class="text-uppercase" [ngSwitch]="participant.status">
                                <strong class="text-blue" *ngSwitchCase="OrderClientStatus.ACCEPTED">{{
                                    'operative.sign-statuses.accepted' | translate
                                }}</strong>
                                <strong class="text-error" *ngSwitchCase="OrderClientStatus.REJECTED">{{
                                    'operative.sign-statuses.rejected' | translate
                                }}</strong>
                                <strong class="text-error" *ngSwitchCase="OrderClientStatus.SENT">{{
                                    'operative.sign-statuses.sent' | translate
                                }}</strong>
                                <strong class="text-error" *ngSwitchCase="OrderClientStatus.EXPIRED">{{
                                    'operative.sign-statuses.expired' | translate
                                }}</strong>
                                <strong class="text-error" *ngSwitchCase="OrderClientStatus.NON_SUCCESSFUL_SIGNATURE">{{
                                    'operative.sign-statuses.non_successful_signature' | translate
                                }}</strong>
                                <strong class="text-error" *ngSwitchDefault>{{ 'operative.sign-statuses.pending' | translate }}</strong>
                            </td>
                            <td *ngIf="product.status === SelectedProductStatus.FOR_SIGNING && product.hasElectronicSign">
                                <ng-container *ngIf="participant.status === OrderClientStatus.PENDING">
                                    <button
                                        type="button"
                                        class="mat-elevation-z0"
                                        mat-raised-button
                                        color="white-bordered"
                                        [disabled]="!canSign"
                                        (click)="onSign(participant)"
                                        *ngIf="participant.signatureType === ClientSignatureType.IN_PERSON_ELECTRONIC"
                                    >
                                        {{ 'general.sign' | translate }}
                                    </button>
                                    <button
                                        type="button"
                                        class="mat-elevation-z0"
                                        mat-raised-button
                                        color="white-bordered"
                                        [disabled]="!canSign"
                                        (click)="onRemember(participant)"
                                        *ngIf="participant.signatureType === ClientSignatureType.REMOTE_ELECTRONIC"
                                    >
                                        {{ 'general.remember' | translate }}
                                    </button>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>

        <div class="order-footer">
            <div class="text-right">
                <ng-container *ngIf="canEdit && !isValidator()">
                    <button type="button" class="mat-elevation-z0 mr-sm-2" mat-raised-button color="yellow-bordered" (click)="onEdit()">
                        {{ 'general.edit' | translate }}
                    </button>
                    <div class="mb-2 d-sm-none"></div>
                </ng-container>
                <ng-container *ngIf="canDelete && !isValidator()">
                    <button
                        type="button"
                        class="mat-elevation-z0 mr-sm-2"
                        mat-raised-button
                        color="yellow-bordered"
                        (click)="onCancelPeriod()"
                    >
                        {{ 'product.cancel-period' | translate }}
                    </button>
                    <div class="mb-2 d-sm-none"></div>
                </ng-container>
                <button type="button" class="mat-elevation-z0" mat-raised-button color="yellow-bordered" (click)="onDetail()">
                    {{ 'product.see-order-detail' | translate }}
                </button>
            </div>
            <ng-container *ngIf="product.status === SelectedProductStatus.FOR_SIGNING && product.hasHandwrittenSign && !isValidator()">
                <h3 class="mat-subheading-1 text-blue font-weight-bold mt-4">
                    {{ 'operative.documents' | translate }}

                    <mat-hint class="d-block mat-caption text-blue font-italic">
                        {{ 'form.documents-help' | translate: { size: 100 } }}
                    </mat-hint>
                </h3>
                <div class="row justify-content-center">
                    <div class="col-12 col-sm-8 col-md-6 col-lg-4">
                        <button
                            type="button"
                            class="btn-download full-width mat-elevation-z0"
                            color="gray-light"
                            mat-flat-button
                            [disabled]="!canSign"
                            (click)="onDownload()"
                        >
                            {{ 'operative.download-sign-documentation' | translate }}
                            <i class="icon-download"></i>
                        </button>
                    </div>
                    <div class="col-12 col-sm-8 col-md-6 col-lg-4 mt-3 mt-md-0">
                        <input
                            #signedDocument
                            name="signedDocument"
                            type="file"
                            class="custom-file-input"
                            accept="image/jpeg,image/png,application/pdf"
                            (change)="onFileChange($event)"
                            multiple
                        />
                        <button
                            type="button"
                            class="btn-upload full-width mat-elevation-z0"
                            color="gray-light"
                            mat-flat-button
                            [disabled]="!canSign"
                            (click)="onUpload()"
                        >
                            {{ 'operative.upload-sign-documentation' | translate }}
                            <i class="icon-download"></i>
                        </button>
                        <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="documentError">
                            {{ documentError }}
                        </mat-error>
                    </div>
                    <div class="col-12 col-sm-8 col-md-6 col-lg-4 mt-3 mt-lg-0">
                        <button
                            type="button"
                            class="btn-validate full-width mat-elevation-z0"
                            color="gray-light"
                            mat-flat-button
                            [disabled]="!canSign"
                            (click)="onValidate()"
                        >
                            {{ 'operative.finish-signature-process' | translate }}
                        </button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="product.documents">
                <ng-template ngFor let-document [ngForOf]="product.documents" let-i="index">
                    <div class="mt-4">
                        <thr-file-selector
                            [name]="'signedDocument' + i"
                            [label]="document.name"
                            [filename]="document.filename"
                            [canView]="document.id && !document.file"
                            [canRemove]="document.allowRemove"
                            [readonly]="true"
                            [disabled]="product.status !== SelectedProductStatus.FOR_SIGNING"
                            [(ngModel)]="document.file"
                            (view)="onDocumentView(document)"
                            (remove)="onDocumentRemove(document)"
                        ></thr-file-selector>
                    </div>
                </ng-template>
            </ng-container>
        </div>
    </mat-card>
</ng-container>
